module.exports = __webpack_public_path__ + "static/img/kc.085e307.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/kc.jpg
// module id = Dyrs
// module chunks = 1